(() => {
  function init(root = document) {
    root.querySelectorAll('[data-bi-header]').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const dialog = header.querySelector('.bi-menu-dialog');
      const open = header.querySelector('[data-bi-open]');
      const tabs = [...dialog.querySelectorAll('[role="tab"]')];
      const panels = [...dialog.querySelectorAll('[role="tabpanel"]')];
      const close = () => dialog.close();
      open.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('bi-menu-open');
        open.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector('[data-bi-close]').addEventListener('click', close);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bi-menu-open');
        open.setAttribute('aria-expanded', 'false');
        open.focus({ preventScroll: true });
      });
      dialog.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
      function select(tab) {
        tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', e => {
          let next;
          if (['ArrowDown', 'ArrowRight'].includes(e.key)) next = (i + 1) % tabs.length;
          if (['ArrowUp', 'ArrowLeft'].includes(e.key)) next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
    root.querySelectorAll('[data-bi-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-bi-slide]')];
      const controls = [...hero.querySelectorAll('[data-bi-slide-button]')];
      controls.forEach((b, i) => b.addEventListener('click', () => {
        slides.forEach((slide, n) => slide.hidden = i !== n);
        controls.forEach((button, n) => button.setAttribute('aria-pressed', String(i === n)));
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
